const projects = [
  {
    title:`Clinic Online Booking App`,
    description:'An app to allow online booking for the clinic I work in. This is meant to work in conjunction with Vital One EMR system. It allows for clients to book appointments with providers and subsequently have video consultations with them.',
    technologies: ['express', 'ReactJS', 'simple-peer', 'Mongo with mongoose', 'PassportJS', 'socket.io', 'bcrypt'],
    github:'https://github.com/neocheekiong/promises-online-booking',
    deployment: 'https://promises-booking-app.herokuapp.com/'
  },
  {
    title:`Pinapps`,
    description:'A place to collate your favourite apps and share them with others. A collaboration with <a class=\'link\' href=\'https://github.com/siewla\'>Pang Siew La</a class=\'link\'>. ',
    technologies: ['express', 'ReactJS','MongoDB', 'cloudinary', 'capture-website', 'bcrypt', 'cors', 'express-jwt', 'google auth', 'Material Design Bootstrap for React', 'react-promise-tracker', 'mongoose', 'moment', 'react-loading'],
    github:'https://github.com/siewla/pinapps',
    deployment: 'https://pinapps.herokuapp.com/'
  },
  {
    title:`Certification Board Website`,
    description:'A Website for a Certification Board. Applicants can apply for the certification with their credentials. A Registrar will then approve their applications.',
    technologies: ['MongoDB', 'ejs', 'expressJS','bcrypt','express-sessions', 'cloudinary'],
    github:'https://github.com/neocheekiong/APCB-website',
    deployment: 'https://apcb.herokuapp.com/'
  },
  {
    title:`You Don't Know Singapore`,
    description:'Some Singapore trivia based on a map of Singapore.',
    technologies: ['Mapbox', 'jQuery'],
    github:'https://github.com/neocheekiong/you-dont-know-singapore/',
    deployment: 'https://neocheekiong.github.io/you-dont-know-singapore/'
  }
]

export default projects
